import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ChatBubbleOutlineOutlinedIcon from '@material-ui/icons/ChatBubbleOutlineOutlined';
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import { BottomNavigation, BottomNavigationAction } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    maxWidth: 500,
  },
});

export default function AppHome2() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Paper square className={classes.root}>
      {/* <Tabs
        value={value}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="secondary"
        textColor="secondary"
        aria-label="icon label tabs example"
      >
        <Tab icon={<ChatBubbleOutlineOutlinedIcon />} label="Chat" />
        <Tab icon={<CallOutlinedIcon />} label="Call" />
      </Tabs> */}

      <div style={{ height: '100%' }}>'{value}'</div>

      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction label="Chat" icon={<ChatBubbleOutlineOutlinedIcon />} />
        <BottomNavigationAction label="Call" icon={<CallOutlinedIcon />} />
      </BottomNavigation>
    </Paper>
  );
}
